import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import getTabBarItems from '../../utils/helpers/getTabBarItems';
import TabBarItem from './TabBarItem';
import { useBridgeState } from '../../bridge';
import SelectLeasedModal from '../ItemCreationForm/SelectLeasedModal';
import useNewItemLocalState from '../../hooks/useNewItemLocalState';
import { toggleAddNewItemModal } from '../../actions';

const TabBar = () => {
  const { t } = useTranslation();
  const { isWebView, insets } = useBridgeState();
  const dispatch = useDispatch();
  const isAddFormVisible = useSelector(
    state => state.addNewItemModal.isVisible
  );
  const { newItemFirstModalValue, newItemSecondModalValue, setSessionKey } =
    useNewItemLocalState();

  const bottomInsetStyles = useMemo(() => {
    if (isWebView) {
      return {
        height: insets.bottom + 53
      };
    }
    return null;
  }, [isWebView, insets]);

  const tabBarItems = getTabBarItems(t);

  useEffect(() => {
    if (newItemFirstModalValue || newItemSecondModalValue) {
      dispatch(toggleAddNewItemModal(true));
    }
    setSessionKey();
  }, []);

  return (
    <div className="tab-bar-container">
      <div
        className="tab-bar"
        {...(bottomInsetStyles ? { style: bottomInsetStyles } : {})}
      >
        <ul className="tab-bar__list">
          {tabBarItems.map((item, i) => (
            <TabBarItem key={`item_${i}`} {...{ item }} />
          ))}
        </ul>
      </div>
      {isAddFormVisible && <SelectLeasedModal />}
    </div>
  );
};

TabBar.propTypes = {
  headerTitle: PropTypes.string
};

export default TabBar;
